import React, { useContext } from 'react';
import { OverlayContext, OverlayViewProps } from '../../context/overlay';

const OverlayView:React.FC = ({
  children,
}) => {
  const overlay = useContext<OverlayViewProps>(OverlayContext);

  return (
    <div className="relative">
      <div className="">{children}</div>
      {overlay.viewContent
          && (
          <div>
            <div className="absolute z-20 bg-black/40 w-screen h-full left-0 top-0" />
            <div className="z-20 fixed bottom-0 left-0 w-full">{overlay.viewContent}</div>
          </div>
          )}
    </div>
  );
};

export default OverlayView;
